import { Injectable } from '@angular/core'

export interface Color {
  r: number
  g: number
  b: number
}

@Injectable({
  providedIn: 'root'
})
export class InvaderService {
  seed: number = Date.now() // 42
  size: number = 7 // 5, 7, 9
  colorRange: number[] = [42, 240]

  constructor() {
  }

  r() {
    const x = Math.sin(this.seed++) * 10000
    return x - Math.floor(x)
  }

  ri(a: number, b: number) {
    const x = Math.sin(this.seed++) * 10000
    return Math.floor(a + (x - Math.floor(x)) * (b - a))
  }

  generate() {
    let invader = new Array(this.size * this.size).fill(0)
    const color1 = this.getColor(this.colorRange)
    const color2 = this.getColor(this.colorRange)
    const color3 = this.getColor(this.colorRange)

    invader.map((_, i, a) => {
      let color = this.r() > 0.5 ? color1 : color3
      color = this.r() > 0.5 ? color : color2

      a[i] = this.r() > 0.5 ? color : 0
    })

    return this.reflect(invader, this.size)
  }

  reflect(input: any[], size: number) {
    const invader = [...input]
    for (let x = 0; x < size; x++) for (let y = 0; y < size / 2; y++)
      invader[x + y * size] = invader[x + (size - 1 - y) * size]
    return invader
  }

  getColor(colorRange: number[]): Color {
    const [a, b] = colorRange
    return {r: this.ri(a, b), g: this.ri(a, b), b: this.ri(a, b)}
  }
}
